'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.addYears;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/addYears.js
// module id = 246
// module chunks = 0